import {
  updateChatChannelName,
  updateChatIdentity,
  removeChatChannelName,
  removeChatIdentity,
  updateDocumentTitle,
} from 'src/utils/helpers'

export function setChatData(data, user, isChatEmpty) {
  return {
    type: 'SET_CHAT_DATA',
    payload: {
      data,
      user,
      isChatEmpty,
    }
  }
}

export function updateChatSessionState(user, isChatEmpty, updateCookie = true) {
  if (updateCookie) {
    // It will set chat identity and channel name cookies to expire if chat is not empty (there are chat messages)
    updateChatChannelName(user, isChatEmpty)
    updateChatIdentity(user, isChatEmpty)
  }

  return {
    type: 'SET_IS_CHAT_EMPTY',
    payload: {
      isChatEmpty,
    }
  }
}

/**
 * Clear chat identity cookie and clear chat data in storage.
 *
 * @param isReloadRequired Re-rendering is needed only if currently on /chat page
 * @param history Provided using "withRouter" from 'react-router-dom'
 */
export function resetChat(isReloadRequired = false, history = null) {
  return (dispatch) => {

    // Remove cookies holding chat channel name and identity
    removeChatChannelName()
    removeChatIdentity()

    // Reset document title
    updateDocumentTitle()

    dispatch({
      type: 'RESET_CHAT_SESSION',
    })

    if(isReloadRequired && history) {
      history.push('/')
    }
  }
}

// export function updateToken(token) {
//   return {
//     type: 'UPDATE_TOKEN',
//     payload: { token }
//   }
// }

export function setChatEmail(chatEmail) {
  return {
    type: 'SET_CHAT_EMAIL',
    payload: {
      chatEmail,
    }
  }
}

export function updateUnreadCount(unreadCount) {
  return {
    type: 'UPDATE_UNREAD_COUNT',
    payload: {
      unreadCount,
    }
  }
}
